module.exports = __webpack_public_path__ + "static/media/ū_64k.917fbb46.mp3";